import { Action, checkedFetchAccessTokenIfNeeded } from '~/AccessToken';
import { resetPassword } from '~/PasswordReset';
import { ThunkAction } from '~/Store';

export function resetCurrentUserPassword(): ThunkAction<Promise<void>, Action> {
	return async (dispatch) => {
		const response = await dispatch(checkedFetchAccessTokenIfNeeded());
		if (response) {
			await dispatch(resetPassword(response.accessToken.user.email));
		}
	};
}
